import { createApp } from 'vue'
import router from './router/index'
import store from './store/index'
import App from './App.vue'
import './normalize.css'
import './index.scss'

const app = createApp(App)
app.use(router).use(store).mount('#app')
